import { 
    TAREAS_PROYECTO,
    AGREGAR_TAREA,
    VALIDACION_CAMPO,
    ELIMINAR_TAREA,
    TAREA_SELECCIONADA,
    ACTUALIZAR_TAREA,
    LIMPIAR_TAREA,
    VER_TAREA,
    TAREA_ACTUAL,
    OBTENER_DESCRIPCIONES,
    AGREGAR_DESCRIPCION,
    ELIMINAR_DESCRIPCION,
    DESCRIPCION_SELECCIONADA,
    LIMPIAR_DESCRIPCION,
    ACTUALIZAR_DESCRIPCION,
    CAMBIAR_FORMULARIO,
    REINICIAR_TAREA_STATE
} from '../../types';

export default (state, action) => {
    switch(action.type) {
        case TAREAS_PROYECTO:
            return {
                ...state,
                tareasproyecto: action.payload
            }
        case AGREGAR_TAREA:
            return {
                ...state,
                tareasproyecto: [action.payload, ...state.tareasproyecto],
                errorcampo: false
            }
        case VALIDACION_CAMPO:
            return {
                ...state,
                errorcampo: action.payload
            }
        case ELIMINAR_TAREA:
            return {
                ...state,
                tareasproyecto: state.tareasproyecto.filter(tarea => tarea._id !== action.payload)
            }
        case ACTUALIZAR_TAREA:
            return {
                ...state,
                tareasproyecto: state.tareasproyecto.map(tarea => tarea._id === action.payload._id ? action.payload : tarea)
            }
        case TAREA_SELECCIONADA:
            return {
                ...state,
                tareaseleccionada: action.payload
            }
        case LIMPIAR_TAREA:
            return {
                ...state,
                tareaseleccionada: null
            }
        case VER_TAREA:
            return {
                ...state,
                vertarea: action.payload
            }
        case TAREA_ACTUAL:
            return {
                ...state,
                tareaactual: action.payload
            }
        case OBTENER_DESCRIPCIONES:
            return {
                ...state,
                descripcionestarea: action.payload
            }
        case AGREGAR_DESCRIPCION:
            return {
                ...state,
                descripciones: [action.payload, ...state.descripcionestarea],
                errorcampo: false
            }
        case ELIMINAR_DESCRIPCION:
            return {
                ...state,
                descripcionestarea: state.descripcionestarea.filter(descripcion => descripcion._id !== action.payload)
            }
        case DESCRIPCION_SELECCIONADA:
            return {
                ...state,
                descripcionseleccionada: action.payload
            }
        case LIMPIAR_DESCRIPCION:
            return {
                ...state,
                descripcionseleccionada: null
            }
        case ACTUALIZAR_DESCRIPCION:
            return {
                ...state,
                descripcionestarea: state.descripcionestarea.map(descripcion => descripcion._id === action.payload._id ? action.payload : descripcion)
            }
        case CAMBIAR_FORMULARIO:
            return {
                ...state,
                formulariodescripcion: action.payload
            }
        case REINICIAR_TAREA_STATE:
            return {
                ...state,
                tareasproyecto: [],
                descripcionestarea: [],
                errorcampo: false,
                tareaseleccionada: null,
                descripcionseleccionada: null,
                vertarea: false,
                tareaactual: '',
                formulariodescripcion: false
            }
        default:
            return state;
    }
}